








import { DataModules } from "@/store/modules/data";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "content-header-control": () =>
      import("@/skeleton/admin/loggedIn/contentHeaderControl.vue")
  }
})
export default class ContentHeaderVerifyPin extends Vue {
  // Methods

  public openVerifyModal() {
    this.$store.dispatch(`data/${DataModules.CLIENTS}/openVerifyPinModal`);
  }
}
